const EV_BANNER_ID = 'evBanner';
const TARIFF_CONTENT_ID = 'tariffType';

export { EV_BANNER_ID, TARIFF_CONTENT_ID };
